export class SmeltingProductionQuality {
  constructor({
        id= null, 
        planCode= ``, 
        day= ``,
        locName= ``,          
        shift='',
        productName= ``,
        itemName='',
    } = {}) {
    this.id = id;
    this.planCode = planCode;
    this.day = day;
    this.locName = locName;     
    this.shift = shift;  
    this.productName = productName;
    this.itemName = itemName;
  }
}
export function gridFields() {
  return Object.freeze([         
      {
        key: 'planCode',
        label: 'lbl.basic.planCode',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'locName',
        label: 'lbl.basic.locName',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'day',
        label: 'lbl.basic.day',
        sortable: true,
        form: {
          type: 'datepicker'
        }
      },  
      {
        key: 'shift',
        label: 'lbl.basic.shift',
        sortable: true,
        form: {
          type: 'input'
        }
      },                       
      {
        key: 'productName',
        label: 'lbl.prd.execution.productionName',
        sortable: false,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'itemName',
        label: 'lbl.prd.execution.itemName',
        sortable: false,
        form: {
          type: 'input'
        }
      },
  ]);
}
export const fields = Object.freeze(Object.keys(new SmeltingProductionQuality()).map(i => 'entity.' + i));
export const filterFields = [
  'filter.locNameFilter',
  'filter.shiftFilter',
  'filter.startDayFilter',
  'filter.endDayFilter', 
];
export const filter = {
  'locNameFilter': "",    
    'startDayFilter': "",
    'endDayFilter': "",
    'shiftFilter': "",
};